import { useEffect, useRef } from "react";

import { useRuntimeContext } from "@/features/tutor/context/RuntimeContext";
import { useChatAvailability } from "@/features/tutor/hooks/useChatAvailability";
import { useWebsocketStore } from "@/features/tutor/store/useWebsocketStore";

export const useInputModeReporter = (): void => {
  const { emit } = useRuntimeContext() ?? {};
  const connected = useWebsocketStore((s) => s.wsConnected);
  const { renderedMode } = useChatAvailability();
  const reported = useRef<string | null>(null);

  useEffect(() => {
    if (!connected || !emit) {
      reported.current = null;
      return;
    }
    if (reported.current === renderedMode) return;

    reported.current = renderedMode;
    emit("INPUT_MODE_CHANGED", renderedMode);
  }, [connected, emit, renderedMode]);
};
